import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import AppSections from "../utils/AppSections";
import ConditionReports from "../ui/condition_reports/ConditionReports";

const ConditionReportsRoutes = (
  <Route
    path={AppSections.CONDITION_REPORTS}
    element={
      <ProtectedRoute>
        <ConditionReports />
      </ProtectedRoute>
    }
  >
    {/* <Route path=":cid/edit" element={<ConditionReportAddEdit />} />  */}
  </Route>
);

export default ConditionReportsRoutes;
